<template>
  <div>
      <div v-if="dashboardFlags.evsensAdminFlag===true" class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayFilter===0">
                          <button type="button" @click="toggleDisplayFilter()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayFilter">
                          <button  type="button" @click="toggleDisplayFilter()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayFilter()"><i class="fa fa-filter fa-1x push-5-r "></i>{{ sectionLabelFilters[actualLanguage] }}</h2>
            </div>

            <!-- ================================================================= -->
            <!-- Section des filtre de channel-->
            <!-- ================================================================= -->

            <div v-if="flagDisplayFilter===-1" class="block-content">
              <div  class="row items-push">
                <div class="col-xs-12">
                  <div v-for = "(categoryList ,index) in actualBundle.channelsAttributes">
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                          <div class="form-group">
                              <label class="col-xs-12" for="example-multiple-select"><i class="fa fa-tags fa-1x push-5-r "></i>{{categoryList.title}}</label>
                                <div class="col-sm-12">
                                    <select  class="form-control" v-model="attributesFiltersChoice[index]" id="example-multiple-select" name="example-multiple-select" size="4" multiple>
                                        <option v-for= "(element, index2) in attributesFilters[index]" :value="element">{{element}}</option>
                                    </select>
                                </div>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-xs-12 col-sm-6">
                    <button type="button" style="color:white" @click="resetDisplayFlag()" class="btn btn-danger"><i class="fa fa-eraser fa-1x push-5-r "></i>{{ buttonLabelEraseFilter[actualLanguage] }}</button>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <button type="button" @click="applyFilter()" class="btn btn-success align-right" ><i class="fa fa-filter fa-1x push-5-r "></i>{{ buttonApplyFilters[actualLanguage] }}</button>
                  </div>
                </div>
              </div>

              <div  class="row items-push">
                <div class="col-xs-12 col-sm-12 align-center push">
                  <button type="button" @click="refreshPie()" class="btn btn-success align-center" ><i class="fa fa-refresh fa-1x push-5-r "></i>{{ buttonPieChartRefresh[actualLanguage] }}</button>
                </div>
              </div>

            </div>

        </div>
      </div>
      </div>
    </div>

    <!-- ================================================================= -->
    <!-- Section affichage des channel sur la map-->
    <!-- ================================================================= -->
    <div v-if="false" class="row">
      <div class="col-xs-12">
        <div class="block block-bordered">
          <div class="block block-themed">
          <div class="block-header bg-muted">
                <ul  class="block-options">
                    <li v-if="flagDisplayMap===0">
                        <button type="button" @click="toggleDisplayMap()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                    </li>
                    <li v-if="flagDisplayMap">
                        <button  type="button" @click="toggleDisplayMap()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                    </li>
                </ul>
            <h2 class="block-title" @click="toggleDisplayMap()"><i class="fa fa-map-marker fa-1x push-5-r "></i>{{ sectionLabelDeviceLocalisation[actualLanguage] }}</h2>
          </div>

          <div v-if="flagDisplayMap===-1" class="block-content">

            <div v-if = "showListOfChannel" class="row">
              
              <Gmap-Map style="width: 100%; height: 400px;" :zoom="8" :center="center">
                <Gmap-Marker v-for="(marker, index) in markers"
                  :key="index"
                  :position="marker.position"
                  :label="marker.label"
                  :draggable='false'
                  ></Gmap-Marker>
              </Gmap-Map>

            </div>


          </div>

      </div>
    </div>
    </div>
  </div>



  <div class="row push">
    <div v-if = "showPieChart && crunchedCost.datasets[0].data.length > 0 && actualBundle.bundle_configuration.channelDisplayOptions.pieChartDisplayFlag" class="block-content push">


        <div v-if="flagDisplayOldGraph" class="col-xs-4">
          <label class="col-xs-12 align-center" for="example-multiple-select">{{ labelPieConsumption[actualLanguage] }}</label>
          <pie-chart :chartData="crunchedCunsumption"></pie-chart>
        </div>

        <div v-if="flagDisplayOldGraph" class="col-xs-4">
          <label class="col-xs-12 align-center" for="example-multiple-select">{{ labelPieCost[actualLanguage] }}</label>
          <pie-chart :chartData="crunchedCost"></pie-chart>
        </div>

        <div v-if="flagDisplayOldGraph" class="col-xs-4">
          <label class="col-xs-12 align-center" for="example-multiple-select">{{ labelPieMaximumCurrent[actualLanguage] }}</label>
          <pie-chart :chartData="crunchedMaxCurrent"></pie-chart>
        </div>

        <div v-if="flagDisplayNewGraph" class="col-xs-12 col-sm-12 col-lg-6">
          <h3 class="align-center">{{ labelPieConsumption[actualLanguage] }}</h3>
            <div id="chart">
              <apexchart  :options="pieChartOptionsKWH" :series="pieChartDataSeriesKWH"></apexchart>
            </div>
        </div>

        <div v-if="flagDisplayNewGraph" class="col-xs-12 col-sm-12 col-lg-6">
          <h3 class="align-center">{{ labelPieCost[actualLanguage] }}</h3>
            <div id="chart">
              <apexchart  :options="pieChartOptionsCost" :series="pieChartDataSeriesCost"></apexchart>
            </div>
        </div>

    </div>
  </div>






<div v-if="displayAsTableFlag" >
  <!-- ================================================================= -->
  <!-- Affichage en format liste (Table des channel d'appareils EV Sens : -->
  <!-- actualBundle.channels[index].FrontendTemplates.componentChannelDisplay=='EVA_V1P00'" -->
  <!-- ================================================================= -->

  <div class="col-xs-12 col-sm-12 push align-center">
        <button type="button" @click="toggleDisplayTable()" class="btn btn-success align-center" ><i class="fa fa-bars fa-1x push-5-r "></i> {{ buttonLabelDisplayDetail[actualLanguage] }}</button>
  </div>


  <div v-if="EvSenschannelCounter > 0" class="col-xs-12 col-sm-12">
    <div class="col-xs-12 col-sm-3"></div>
    <div class="col-xs-12 col-sm-6">
      <select class="form-control" @click="updatePieChartData()" v-model=selectedGraphCurve  size="1">
        <option value="AvrPower">{{labelSelectorAvrPowerKW[actualLanguage]}}</option>
        <option value="PeakPower">{{labelSelectorPeakPowerKW[actualLanguage]}}</option>
        <option value="KWH_PerSample">{{labelSelectorKWHShort[actualLanguage]}}</option>
        <option value="Cost_PerSample">{{labelSelectorCostShort[actualLanguage]}}</option>
        <option value="CumSumKWH">{{labelSelectorCumSumKWH[actualLanguage]}}</option>
        <option value="CumSumCost">{{labelSelectorCumSumCost[actualLanguage]}}</option>
      </select>
    </div>
    <div class="col-xs-12 col-sm-3"></div>
  </div>

  <div v-if="EvSenschannelCounter > 0" class="col-xs-12 col-sm-12">
    <div id="chart">
      <apexchart type="area" height="400" :options="chartOptions" :series="chartDataSeries"></apexchart>
    </div>
    <div class="col-xs-12 col-sm-12 push align-center">
      <h6 class="font-w200 align-center push">{{ textLabelRequireDeviceSelect[actualLanguage] }}</h6>
    </div>
  </div>

  
  
  <div class="col-xs-12 col-sm-12">
    <div class="table-responsive">
      <table  class="table remove-margin-b font-s12">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{{ tableLabelDevice[actualLanguage] }}</th>
            <th>{{ tableLabelOnline[actualLanguage] }}</th>
            <th >{{ tableLabelMaxCurrent[actualLanguage] }}</th>
            <th >{{ tableLabelCunsumption[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual">{{ tableLabelLastReading[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H">{{ tableLabelMA_1Hr[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H">{{ tableLabelMA_4Hr[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H">{{ tableLabelMA_6Hr[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H">{{ tableLabelMA_12Hr[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H">{{ tableLabelMA_1Day[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H">{{ tableLabelMA_3Day[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H">{{ tableLabelMA_7Day[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H">{{ tableLabelMA_14Day[actualLanguage] }}</th>
            <th v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H">{{ tableLabelMA_30Day[actualLanguage] }}</th>

          </tr>
        </thead>


        <tbody>
          <tr v-for="(flag,index) in subBundleDisplayFlag">
            <td v-if="flag" class="font-w600" >
              <i v-if="actualBundle.sub_bundle[index].subBundleData.bundle_icon == 'Undefined.png'" class="fa fa-usb fa-2x push-5-r "></i>
              <img v-else class="measurement-graph-row__icon" width="50px" :src="`systems_icons/${actualBundle.sub_bundle[index].subBundleData.bundle_icon}` | s3Image" alt="">
            </td>
            <td v-if="flag">X</td>
            <td v-if="flag" class="font-w600" >{{index+1}} : {{actualBundle.sub_bundle[index].ReferenceName}}</td>
            <td v-if="flag" class="font-w600" ></td>
            <td v-if="flag" class="font-w600"></td>
            <td v-if="flag" class="font-w600"></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'5min'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_001H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_004H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_006H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_012H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_024H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_072H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_168H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_336H'}" ></relative-power-bar-mini></td>
            <td v-if="flag && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'BDL','index':index,'MAType':'MA_720H'}" ></relative-power-bar-mini></td>
          </tr>  

          <tr v-for="(flag,index) in channelDisplayFlag">         
              <td v-if="flag && flagChannelIsEvsensChannel[index]" class="font-w600" >
                <i v-if="actualBundle.channels[index].ChannelData.channelInfo.iconFile == 'Undefined.png'" class="fa fa-television fa-2x push-5-r "></i>
                <img v-else class="measurement-graph-row__icon" width="50px" :src="`appliances/${actualBundle.channels[index].ChannelData.channelInfo.iconFile}` | s3Image" alt="">
              </td>
              <td v-if="flag && flagChannelIsEvsensChannel[index]" class="font-w600" @click="toggleChannelDisplayFlag(index)"><input type="checkbox" v-model="actualBundle.channels[index].ChannelData.DisplayOpenFlag"></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index]" class="font-w600" >{{index+1}} : {{actualBundle.channels[index].ReferenceName}}</td>
              <td v-if="flag && flagChannelIsEvsensChannel[index]" class="font-w600" ><i v-if="actualBundle.channels[index].ChannelData.deviceOnline" class="fa fa-toggle-on fa-2x"></i><i v-else class="fa fa-toggle-off fa-2x"></i></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.channels[index].ChannelData.DisplayOpenFlag" class="font-w600">{{actualBundle.channels[index].ChannelData.peakCurrent | round}} A</td><td v-else-if="flag">---</td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.channels[index].ChannelData.DisplayOpenFlag" class="font-w600">{{actualBundle.channels[index].ChannelData.sumKwh | round}} kWh/ {{actualBundle.channels[index].ChannelData.sumCost | toCurrency }}</td><td v-else-if="flag">---</td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'5min'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_001H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_004H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_006H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_012H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_024H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_072H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_168H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_336H'}" ></relative-power-bar-mini></td>
              <td v-if="flag && flagChannelIsEvsensChannel[index] && (channelDisplayTemplate[index]=='EVA_V1P00') && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H" class="font-w600"><relative-power-bar-mini  :barParameters="{'type':'CHN','index':index,'MAType':'MA_720H'}" ></relative-power-bar-mini></td>
          </tr>
          
        </tbody>
      </table>

      <!-- ================================================================= -->
      <!-- Affichage en format liste des channel de device d'API client -->
      <!-- ================================================================= -->

    </div>
  </div>

  <!-- ================================================================= -->
  <!-- Affichage en format liste des channel de device de API device -->
  <!-- ================================================================= -->
  <div v-for="(flag,index2) in channelDisplayFlag">
    <div v-if="flag && actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay=='ApiDevice_V1P00'">
      <div class="col-sm-12">
        <div class="col-xs-4 col-sm-3">
          <div class="col-sm-2">
            <td v-if="flag" class="font-w600"><input type="checkbox" v-model="actualBundle.channels[index2].ChannelData.DisplayOpenFlag"></td>
          </div>
          <div class="col-sm-10">
            <h5 class="font-w300 push measurement-graph-row__title">
              <img class="measurement-graph-row__icon" width="60px" :src="`organization_img/${actualBundle.channels[index2].ChannelData.channelInfo.iconFile}` | s3Image" alt="">
              {{actualBundle.channels[index2].ReferenceName}}
            </h5>
          </div>
        </div>
        <div class="col-xs-12 col-sm-9">
          <api-device-list-indicator-v1p00  :componentListIndicators="actualBundle.channels[index2].ChannelData.Readings.listIndicators" ></api-device-list-indicator-v1p00>
        </div>
      </div>
    </div>
  </div>


</div>
<div v-else>
  <div class="col-xs-12 col-sm-12 push align-center">
        <button type="button" @click="toggleDisplayTable()" class="btn btn-success align-center" ><i class="fa fa-list fa-1x push-5-r "></i>{{ buttonLabelDisplayList[actualLanguage] }}</button>
  </div>
  <div v-if = "showListOfChannel">

    <div v-if = "actualBundle['sub_bundle'].length">
      <h3 class="font-w300 push">{{ textLabelSubSystem[actualLanguage] }}</h3>
      <div v-for="(flag,index) in subBundleDisplayFlag">
          <display-sub-bundle v-if="flag" :subBundleIndex="index" ></display-sub-bundle>
      </div>
    </div>

    <div v-if = "actualBundle['channels'].length">
      <h3 class="font-w300 push">{{ textLabelSubDevice[actualLanguage] }}</h3>
      <div v-for="(flag,index) in channelDisplayFlag">
        <display-channel v-if="flag && actualBundle.channels[index].FrontendTemplates.componentChannelDisplay=='EVA_V1P00'" :channelIndex="index" ></display-channel>
      </div>

      <div v-for="(flag,index2) in channelDisplayFlag">
        <api-display-channel-v1p00 v-if="flag && actualBundle.channels[index2].FrontendTemplates.componentChannelDisplay=='ApiDevice_V1P00'" :channelIndex="index2" ></api-display-channel-v1p00>
      </div>

    </div>
  </div>
</div>


</div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapActions,mapGetters} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import DisplayChannel from './DisplayChannel'
import DisplaySubBundle from './DisplaySubBundle'
import PieChart from '@/components/PieChart'
import PieChartPowerAvr from './SubComponents/PieChartPowerAverage'
import RelativePowerBar from './SubComponents/RelativePowerBar.vue'
import RelativePowerBarMini from './SubComponents/RelativePowerBarMini.vue'

import ApiDisplayChannelV1p00 from './ApiDisplayChannelV1p00.vue'
import ApiDeviceListIndicatorV1p00 from './SubComponents/ApiDeviceListIndicatorV1p00.vue'

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
//Next line are executed in PortGraph!!!
//Vue.use(VueApexCharts)
//Vue.component('apexchart', VueApexCharts)



export default {
  //props: ['channelIndex'],
  components: {
    Spinner,
    DisplayChannel,
    DisplaySubBundle,
    PieChartPowerAvr,
    PieChart,
    RelativePowerBar,
    RelativePowerBarMini,
    ApiDisplayChannelV1p00,
    ApiDeviceListIndicatorV1p00,
  },
  data() {
    return {    
      actualLanguage : "FR",
      showListOfChannel : false,
      showPieChart : false,
      flagDisplayFilter : 0,
      flagDisplayMap : 0,
      attributesFilters : [],
      EvSenschannelCounter : 0,
      flagChannelIsEvsensChannel : [],
      channelDisplayFlag : [],
      channelDisplayTemplate:[],
      subBundleDisplayFlag : [],
      attributesFiltersChoice : [],
      channelCount : 0,
      channelsParamaters : [],
      displayAsTableFlag : true,
      channelsMmMaximums : {'5Min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0},
      powerBarDataMA_001H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},

      sectionLabelFilters:{FR: "Filtres des Appareils et Sous-systèmes", EN: 'Device and Sub-Systems filters'},
      buttonLabelEraseFilter:{FR: "Effacer les filtres", EN: 'Erase filters'},
      buttonApplyFilters:{FR: "Appliquer les filtres", EN: 'Apply filters'},
      sectionLabelDeviceLocalisation:{FR: "Localisation des appareils", EN: 'Devices location'},
      buttonPieChartRefresh:{FR: "Actualiser les données de la période sélectionnée", EN: 'Refresh pie data of the selected period'},
      labelPieConsumption:{FR: "Consommation électrique", EN: 'Électrical consumption'},
      labelPieCost:{FR: "Coût", EN: 'Cost'},
      labelPieMaximumCurrent:{FR: "Courant maximum", EN: 'Maximum current'},

      buttonLabelDisplayDetail:{FR: "Afficher en mode detail", EN: 'Display in detail mode'},
      buttonLabelDisplayList:{FR: "Afficher en mode combiné et les moyennes", EN: 'Display in combined mode and average'},
      textLabelRequireDeviceSelect:{FR: "* Utilisez les cases à cocher bleu de la liste du bas pour activer/désactiver l'affichage des données de l'appareil sur les graphiques.",
       EN: '* Use the blue checkboxes in the bottom list to enable/disable the display of device data on charts.'},
      tableLabelDevice:{FR: "Composante", EN: 'Component'},
      tableLabelOnline:{FR: "Connecté", EN: 'On Line'},
      tableLabelMaxCurrent:{FR: "Courant Max*", EN: 'Max current*'},
      tableLabelCunsumption:{FR: "Consommation (kWh/$)*", EN: 'Cunsumption (kWh/$)*'},
      tableLabelLastReading:{FR: "Dernière mesure", EN: 'Last measure'},
      
      tableLabelMA_1Hr:{FR: "Moyenne 1Hr", EN: '1Hr Average'},
      tableLabelMA_4Hr:{FR: "Moyenne 4Hr", EN: '4Hr Average'},
      tableLabelMA_6Hr:{FR: "Moyenne 6Hr", EN: '6Hr Average'},
      tableLabelMA_12Hr:{FR: "Moyenne 12Hr", EN: '12Hr Average'},
      tableLabelMA_1Day:{FR: "Moyenne 1Jr", EN: '1Day Average'},
      tableLabelMA_3Day:{FR: "Moyenne 3Jr", EN: '3Day Average'},
      tableLabelMA_7Day:{FR: "Moyenne 7Jr", EN: '7Day Average'},
      tableLabelMA_14Day:{FR: "Moyenne 14Jr", EN: '14Day Average'},
      tableLabelMA_30Day:{FR: "Moyenne 30Jr", EN: '30Day Average'},
      textLabelSubSystem:{FR: "Sous-Système", EN: 'Sub-Systems'},
      textLabelSubDevice:{FR: "Appareils", EN: 'Devices'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

      labelSelectorAvrPowerKW: {FR: 'Puissance Moyenne (kW)', EN: 'Average Power (kW)'},
      labelSelectorPeakPowerKW: {FR: 'Puissance crête (kW)', EN: 'Peak Power (kW)'},
      labelSelectorKWHShort: {FR: 'kWh par mesure', EN: 'kWr per sample'},
      labelSelectorCostShort: {FR: 'Coût par mesure ($)', EN: 'Cost per sample ($)'},
      labelSelectorCumSumKWH: {FR: 'Consommation cumulée (kWh)', EN: 'Cumulated consumption (kWh)'},
      labelSelectorCumSumCost: {FR: 'Consommation cumulée ($)', EN: 'Cumulated consumption ($)'},





      center: {lat: 46.82, lng: -71.25},
      markers: [{position: {lat: 46.1,lng: -72.4,},label:"1"},
                {position: {lat: 46.1,lng: -73.4,},label:"2"}],

      flagDisplayOldGraph : false,
      crunchedMaxCurrent: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

      crunchedCost: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

      crunchedCunsumption: {
        labels: ['Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40]
        }]
      },

      //--------------------------------------------------------
      //New Graph variables
      //--------------------------------------------------------
      flagDisplayNewGraph : true,

      pieChartDataSeriesKWH: [10,20,30],
      pieChartOptionsKWH:{
        chart:{
          type:'pie',
        },
        pie:{
          expandOnClick:true,
          customScale:0.4
          },
        dataLabels:{
          enabled:true,
          style:{fontSize:'16px'},
        },
        labels:['Label1','Label2','Label3']
      },

      pieChartDataSeriesCost: [10,20,30],
      pieChartOptionsCost:{
        chart:{
          type:'pie',
        },
        pie:{
          expandOnClick:true,
          customScale:0.4
          },
        dataLabels:{
          enabled:true,
          style:{fontSize:'16px'},
        },
        labels:['Label1','Label2','Label3']
      },


      selectedGraphCurve: 'AvrPower',

      chartDataSeries: [{
        name: 'TBD',
        data: [[1324508400000, 34], [1324594800000, 54],[1326236400000, 43],[1326236405000, 43],[1326236406000, 53],[1326236406500, 63]],
      }],
        
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 400,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        tooltip:{
            x :{format : 'dd MMM hh:mm'}
          },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            type: 'datetime'
          }
      },


    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','groupArborescence','actualBundle','dashboardFlags']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },
  watch: {
    actualBundle(){
        //this.resetDisplayFlag()
        //this.generatesFiltersList()
        //console.log('---Display channel List : Watch actual bundle---')
        //this.showListOfChannel = false
        this.showPieChart = false
        //this.resetDisplayFlag()
        this.updatePieChartData()


        //https://michaelnthiessen.com/force-re-render/  
        this.$nextTick(() => {
          this.showListOfChannel = true
          this.showPieChart = true
        });

    },
    groupArborescence(){
      //console.log('---Watch arborescence---')
      this.showListOfChannel = false
      this.resetDisplayFlag()
      this.showListOfChannel = true
    }
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayFilter(){
      this.flagDisplayFilter = ~this.flagDisplayFilter
    },
   toggleDisplayMap(){
      this.flagDisplayMap = ~this.flagDisplayMap
    },

    toggleDisplayTable(){
      //window.alert("Call")
      if(this.displayAsTableFlag){
        this.displayAsTableFlag = false
      }else{
        this.displayAsTableFlag = true
      }
    },

    resetDisplayFlag(){
      this.channelDisplayFlag = []
      this.subBundleDisplayFlag = []
      this.flagChannelIsEvsensChannel = []
      var previousDisplayFilter = this.flagDisplayFilter
      this.showListOfChannel = false
      this.showPieChart = false
      this.flagDisplayFilter = 0
      this.channelsMmMaximums = {'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
      this.markers = []
      var positionMarkerNotFound = true
      var mm = 0


      //--------------------------
      //Reset filter on Channels
      //--------------------------
      this.EvSenschannelCounter = 0
      for(var m=0;m<this.actualBundle.channels.length;m++){
        this.channelDisplayFlag[m]=true
        this.validateMmMaximums(m)
        
        this.flagChannelIsEvsensChannel[m] = (this.actualBundle.channels[m].FrontendTemplates.componentChannelDisplay=='EVA_V1P00')

        //We force the display of channel from API device when they are not EVA channel
        if(this.flagChannelIsEvsensChannel[m]==false){
          this.actualBundle.channels[m].ChannelData.DisplayOpenFlag = true
          }else{
            this.EvSenschannelCounter +=1
          }
        

        positionMarkerNotFound = true
        for(mm=0;mm<this.markers.length;mm++){

          if(this.markers[mm].position.lat==this.actualBundle.channels[m].ChannelData.position.latitude &&
            this.markers[mm].position.lng==this.actualBundle.channels[m].ChannelData.position.longitude )
            {positionMarkerNotFound = false
            this.markers[mm].label = this.markers[mm].label.concat("-",(m+1).toString())
            //console.log('position found')
            }
        }

        if(positionMarkerNotFound){
          this.markers.push({position: {lat: this.actualBundle.channels[m].ChannelData.position.latitude,
                                        lng: this.actualBundle.channels[m].ChannelData.position.longitude,},
                            label:(m+1).toString()})
        }
      }

      //--------------------------
      //Reset filter on Sub Channel
      //--------------------------
      for(var m=0;m<this.actualBundle.sub_bundle.length;m++){
        this.subBundleDisplayFlag[m]=true
        this.validateMmMaximumsSubBundle(m)
      }
      


      this.$store.dispatch('sessionStore/setActualBundleChannelMaximums', this.channelsMmMaximums)

      this.generatesFiltersList()
      this.updatePieChartData()
               
      this.flagDisplayFilter = previousDisplayFilter
      this.channelCount = this.actualBundle.channels.length

      this.$nextTick(() => {
        this.showListOfChannel = true
        this.showPieChart = true
      });

    },

    generatesFiltersList(){
        this.attributesFilters = []
        this.attributesFiltersChoice = []
          for(var attrList=0;attrList<this.actualBundle.channelsAttributes.length;attrList++){
            this.attributesFilters.push([])
            this.attributesFiltersChoice.push([])

            for(var m=0;m<this.actualBundle.channels.length;m++){
              if(this.channelDisplayFlag[m]==true){
                if(this.actualBundle.channels[m].Attributes[attrList] != "ND")
                {
                  if(this.attributesFilters[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList])<0)
                  {
                    this.attributesFilters[attrList].push(this.actualBundle.channels[m].Attributes[attrList])
                  }
                }
              }
            }

            for(var m=0;m<this.actualBundle.sub_bundle.length;m++){
              if(this.subBundleDisplayFlag[m]==true){
                if(this.actualBundle.sub_bundle[m].Attributes[attrList] != "ND")
                {
                  if(this.attributesFilters[attrList].indexOf(this.actualBundle.sub_bundle[m].Attributes[attrList])<0)
                  {
                    this.attributesFilters[attrList].push(this.actualBundle.sub_bundle[m].Attributes[attrList])
                  }
                }
              }
            }


          }
    },

    applyFilter(){
      this.showListOfChannel = false
      this.showPieChart = false
      this.flagDisplayFilter = 0
      this.channelsMmMaximums = {'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
      this.markers = []
      var positionMarkerNotFound = true
      var mm = 0

      //--------------------------
      //Apply filter on Channels
      //--------------------------
      console.log('Apply Filter')
      //this.channelDisplayTemplate = []
      for(var m=0;m<this.actualBundle.channels.length;m++){

        for(var attrList=0;attrList<this.actualBundle.channelsAttributes.length;attrList++){
          if(this.attributesFiltersChoice[attrList].length > 0)
          {
            if(this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.channels[m].Attributes[attrList])>=0)
            {
              this.channelDisplayFlag[m]=true
              this.validateMmMaximums(m)
              positionMarkerNotFound = true
              for(mm=0;mm<this.markers.length;mm++){

                if(this.markers[mm].position.lat==this.actualBundle.channels[m].ChannelData.position.latitude &&
                  this.markers[mm].position.lng==this.actualBundle.channels[m].ChannelData.position.longitude )
                  {positionMarkerNotFound = false
                  this.markers[mm].label = this.markers[mm].label.concat("-",(m+1).toString())
                  //console.log('position found')
                  }
              }

              if(positionMarkerNotFound){
                this.markers.push({position: {lat: this.actualBundle.channels[m].ChannelData.position.latitude,
                                              lng: this.actualBundle.channels[m].ChannelData.position.longitude,},
                                  label:(m+1).toString()})
              }
            }
            else{
              this.channelDisplayFlag[m]=false
            }
          }
        }
      }

      //--------------------------
      //Apply filter on Sub Bundle
      //--------------------------
      for(var m=0;m<this.actualBundle.sub_bundle.length;m++){

        for(var attrList=0;attrList<this.actualBundle.channelsAttributes.length;attrList++){
          if(this.attributesFiltersChoice[attrList].length > 0)
          {
            if(this.attributesFiltersChoice[attrList].indexOf(this.actualBundle.sub_bundle[m].Attributes[attrList])>=0)
            {
              this.subBundleDisplayFlag[m]=true
              this.validateMmMaximumsSubBundle(m)
            }
            else{
              this.subBundleDisplayFlag[m]=false
            }
          }
        }
      }





      this.$store.dispatch('sessionStore/setActualBundleChannelMaximums', this.channelsMmMaximums)
      this.generatesFiltersList()
      this.updatePieChartData()
               
        this.$nextTick(() => {
          this.showListOfChannel = true
          this.showPieChart = true
          this.flagDisplayFilter = -1
        });
      
    },

    refreshPie(){
        this.showPieChart = false
        this.updatePieChartData()
        this.$nextTick(() => {
          this.showPieChart = true
        });
    },


    updatePieChartData(){
      this.crunchedMaxCurrent.labels = []
      this.crunchedMaxCurrent.datasets[0].data = []

      this.crunchedCost.labels = []
      this.crunchedCost.datasets[0].data = []

      this.crunchedCunsumption.labels = []
      this.crunchedCunsumption.datasets[0].data = []

      //console.log('-----Actual Bundle Channels-----')
      //console.log(this.actualBundle.channels)

      this.pieChartDataSeriesKWH = []
      this.pieChartOptionsKWH.labels = []
      this.pieChartDataSeriesCost = []
      this.pieChartOptionsCost.labels = []


      this.chartDataSeries = []
      var NewGraphDataTempo = []
      var actualValue = 0.0

      for(var m=0;m<this.actualBundle.channels.length;m++){
        if(this.actualBundle.channels[m].ChannelData.DisplayOpenFlag && this.channelDisplayFlag[m] && this.actualBundle.channels[m].ChannelData.peakCurrent){
          this.crunchedMaxCurrent.labels.push(this.actualBundle.channels[m].ReferenceName)
          this.crunchedCost.labels.push(this.actualBundle.channels[m].ReferenceName)
          this.crunchedCunsumption.labels.push(this.actualBundle.channels[m].ReferenceName)

          this.crunchedMaxCurrent.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.peakCurrent.toFixed(2))
          this.crunchedCost.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.sumCost.toFixed(2))
          this.crunchedCunsumption.datasets[0].data.push(this.actualBundle.channels[m].ChannelData.sumKwh.toFixed(2))

          //console.log(this.actualBundle.channels[m].ChannelData.sumKwh.toFixed(5))
          this.pieChartOptionsKWH.labels.push(this.actualBundle.channels[m].ReferenceName)
          this.pieChartDataSeriesKWH.push(this.actualBundle.channels[m].ChannelData.sumKwh)

          this.pieChartOptionsCost.labels.push(this.actualBundle.channels[m].ReferenceName)
          this.pieChartDataSeriesCost.push(this.actualBundle.channels[m].ChannelData.sumCost)

          //-----Generate data for new graph
          NewGraphDataTempo = []
          actualValue = 0
          for(var i = 0;i < this.actualBundle.channels[m].ChannelData.Readings.length;i++){
            if(this.selectedGraphCurve=='AvrPower'){actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].avrPower/1000}
            if(this.selectedGraphCurve=='PeakPower'){actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].peak/1000}
            if(this.selectedGraphCurve=='KWH_PerSample'){actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].kwr}
            if(this.selectedGraphCurve=='Cost_PerSample'){actualValue = this.actualBundle.channels[m].ChannelData.Readings[i].cost}
            if(this.selectedGraphCurve=='CumSumKWH'){actualValue += this.actualBundle.channels[m].ChannelData.Readings[i].kwr}
            if(this.selectedGraphCurve=='CumSumCost'){actualValue += this.actualBundle.channels[m].ChannelData.Readings[i].cost}

            NewGraphDataTempo.push([this.actualBundle.channels[m].ChannelData.Readings[i].localEpochTime,actualValue.toFixed(3)])
          }
          this.chartDataSeries.push({name:this.actualBundle.channels[m].ReferenceName,
                                  data:NewGraphDataTempo})

        }
      }

    },


    validateMmMaximums(index){
      if(this.actualBundle.channels[index].ChannelData.lastMeasure['5min'] > this.channelsMmMaximums['5min']){
        this.channelsMmMaximums['5min'] = this.actualBundle.channels[index].ChannelData.lastMeasure['5min']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_001H'] > this.channelsMmMaximums['MA_001H']){
        this.channelsMmMaximums['MA_001H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_001H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_004H'] > this.channelsMmMaximums['MA_004H']){
        this.channelsMmMaximums['MA_004H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_004H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_006H'] > this.channelsMmMaximums['MA_006H']){
        this.channelsMmMaximums['MA_006H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_006H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_012H'] > this.channelsMmMaximums['MA_012H']){
        this.channelsMmMaximums['MA_012H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_012H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_024H'] > this.channelsMmMaximums['MA_024H']){
        this.channelsMmMaximums['MA_024H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_024H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_072H'] > this.channelsMmMaximums['MA_072H']){
        this.channelsMmMaximums['MA_072H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_072H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_168H'] > this.channelsMmMaximums['MA_168H']){
        this.channelsMmMaximums['MA_168H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_168H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_336H'] > this.channelsMmMaximums['MA_336H']){
        this.channelsMmMaximums['MA_336H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_336H']}

      if(this.actualBundle.channels[index].ChannelData.lastMeasure['MA_720H'] > this.channelsMmMaximums['MA_720H']){
        this.channelsMmMaximums['MA_720H'] = this.actualBundle.channels[index].ChannelData.lastMeasure['MA_720H']}

    },


    validateMmMaximumsSubBundle(index){
      if(this.actualBundle.sub_bundle[index].lastMeasure['5min'] > this.channelsMmMaximums['5min']){
        this.channelsMmMaximums['5min'] = this.actualBundle.sub_bundle[index].lastMeasure['5min']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_001H'] > this.channelsMmMaximums['MA_001H']){
        this.channelsMmMaximums['MA_001H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_001H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_004H'] > this.channelsMmMaximums['MA_004H']){
        this.channelsMmMaximums['MA_004H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_004H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_006H'] > this.channelsMmMaximums['MA_006H']){
        this.channelsMmMaximums['MA_006H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_006H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_012H'] > this.channelsMmMaximums['MA_012H']){
        this.channelsMmMaximums['MA_012H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_012H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_024H'] > this.channelsMmMaximums['MA_024H']){
        this.channelsMmMaximums['MA_024H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_024H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_072H'] > this.channelsMmMaximums['MA_072H']){
        this.channelsMmMaximums['MA_072H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_072H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_168H'] > this.channelsMmMaximums['MA_168H']){
        this.channelsMmMaximums['MA_168H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_168H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_336H'] > this.channelsMmMaximums['MA_336H']){
        this.channelsMmMaximums['MA_336H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_336H']}

      if(this.actualBundle.sub_bundle[index].lastMeasure['MA_720H'] > this.channelsMmMaximums['MA_720H']){
        this.channelsMmMaximums['MA_720H'] = this.actualBundle.sub_bundle[index].lastMeasure['MA_720H']}

    },



   toggleChannelDisplayFlag(index){
      if(this.actualBundle.channels[index].ChannelData.DisplayOpenFlag){
        this.actualBundle.channels[index].ChannelData.DisplayOpenFlag = false
        this.refreshPie()
      }
      else{
        this.actualBundle.channels[index].ChannelData.DisplayOpenFlag = true
        this.readChannelReadings(index)
      }
      
   },

    readChannelReadings(index){
        //Ce call effectue une mutation de actualBundle, l'affichage sera donc activé par le watcher
        //de actualBundle.
        this.flagChannelDataIsLoading = true
        var requestData = { 'postAction':'GetBundleChannelReadings',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelList':[{'channelData':this.actualBundle.channels[index].ChannelData,
                                            'channelBundleIndex':index}],
                            'start':this.startDate,
                            'end':this.endDate,
                            'dataType':'Automatic',
                            }

        this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                  //console.log('---Channel Read-----')
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            }) 
    },

    openAllChannelAndReadData(){
      var MyChannelList = []
      for(var m=0;m<this.actualBundle.channels.length;m++){
        this.actualBundle.channels[m].ChannelData.DisplayOpenFlag = true
        MyChannelList.push({'channelData':this.actualBundle.channels[m].ChannelData,
                                        'channelBundleIndex':m})
      }

      this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', false)

      var endDate = (moment().unix())
      var requestData = {'postAction':'GetBundleChannelReadings',
                        'bundleId':this.actualBundle.bundle_id,
                        'channelList':MyChannelList,
                        'start':endDate-28800,
                        'end': endDate,
                        'dataType':'Automatic',
                        }

        this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', true)
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            })   

      
    },


    openChannel(channelIndex){
        this.channelSelected = true
    },
    closeChannel(){
        this.channelSelected = false
    },

  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    //console.log('--DisplayChannelList: Mount')
    
    //console.log("====MESURE ACTUAL BUNDLE====")
    //console.log(this.actualBundle)
    //this.resetDisplayFlag()

    //Vérification si le bundle actuelle est de défault bundle, si tel est le cas, activation de l'affichage de tous les channel.
    if(this.actualBundle.bundle_id.includes(':DefaultBundle')){
      //console.log('--DisplayChannelList:Open All Channel Called')
      this.showListOfChannel = false
      this.displayAsTableFlag = true
      this.openAllChannelAndReadData()
    }else{
      this.openAllChannelAndReadData()
      this.updatePieChartData()
    }

    

    if(this.crunchedCunsumption.labels.length>0){this.showPieChart=true}

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
    
    //On load le template dans la variable pour plus facilement utiliser la données en affichage en liste
    for(var m=0;m<this.actualBundle.channels.length;m++){
      this.channelDisplayTemplate[m]=this.actualBundle.channels[m].FrontendTemplates.componentChannelConfig
      }


  },

  beforeMount(){
    this.resetDisplayFlag()
  }


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// DisplayChannelList.vue?8de181c8